import type { ChatRenderMessage } from "./chatDesignsCatalog";

/** Entrada mínima de una fila: lo que lee el SVG del diseño más el id (dedupe). */
export type ChatLineInput = ChatRenderMessage & { id: string };

/**
 * Arma la lista de mensajes que alimenta el SVG de un diseño de chat — la MISMA
 * para el editor (`ChatWidget.tsx`) y el monitor (`ChatWidgetRenderer`, Pixi),
 * así ambos muestran exactamente las mismas filas:
 *  - los mensajes fijados primero (quedan arriba, como las filas fijadas de la
 *    lista legacy);
 *  - después las filas rodantes YA filtradas por plataforma/bloqueos, sin las
 *    que ya están fijadas (fijar guarda un snapshot pero NO saca el mensaje del
 *    buffer vivo; sin este filtro se pintaría dos veces);
 *  - recortado al presupuesto de filas del diseño (`design.maxRows`) reservando
 *    lugar para los pines: `renderChatDesignSvg` se queda con los últimos
 *    `maxRows`, y sin la reserva los pines serían lo primero en caer.
 *
 * `maxRows <= 0` (diseño de la comunidad sin `list`) ⇒ sin recorte, igual que
 * `renderChatDesignSvg`.
 */
export const chatLinesForDesign = <
  P extends ChatLineInput,
  V extends ChatLineInput,
>(
  pinned: readonly P[],
  visible: readonly V[],
  maxRows: number,
): Array<P | V> => {
  const pinnedIds = new Set(pinned.map((p) => p.id));
  const rolling = visible.filter((m) => !pinnedIds.has(m.id));
  if (!(maxRows > 0)) return [...pinned, ...rolling];
  const pins = pinned.slice(-maxRows);
  const room = maxRows - pins.length;
  // OJO: `slice(-0)` devuelve TODO el array, por eso el guard explícito.
  return [...pins, ...(room > 0 ? rolling.slice(-room) : [])];
};
